// src/shared/StatusBannerContext.jsx
import React, { createContext, useState, useContext } from 'react';

export const StatusBannerContext = createContext();

export const StatusBannerProvider = ({ children }) => {
  const [bannerMessage, setBannerMessage] = useState('');
  const [bannerType, setBannerType] = useState('info');

  const showBanner = (message, type = 'info', duration = 4000) => {
    setBannerMessage(message);
    setBannerType(type);
    setTimeout(() => setBannerMessage(''), duration);
  };

  return (
    <StatusBannerContext.Provider value={{ bannerMessage, bannerType, showBanner }}>
      {children}
    </StatusBannerContext.Provider>
  );
};

export const useStatusBanner = () => useContext(StatusBannerContext);
